// removed by extract-text-webpack-plugin
module.exports = {"currency":"CurrencySelect-style__currency__3tdTW","currencyLink":"CurrencySelect-style__currencyLink__2Ku2B","currencyWrap":"CurrencySelect-style__currencyWrap__39nQO","currencySymbol":"CurrencySelect-style__currencySymbol__1KUcB","currencyList":"CurrencySelect-style__currencyList__1mdLq","checkmark":"CurrencySelect-style__checkmark__2KE4J","isActive":"CurrencySelect-style__isActive__1qw5I","arrowDown":"CurrencySelect-style__arrowDown__23wsM","dropdownWrapper":"CurrencySelect-style__dropdownWrapper__35fb3"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/CurrencySelect/CurrencySelect-style.scss
// module id = 2977
// module chunks = 64